//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AdditionalBlock from './AdditionalBlock.vue'

export default {
  components: {
    AdditionalBlock
  },
  props: {
    routeSources: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getRouteSourceByType: function (type) {
      return this.routeSources && this.routeSources.find(routeSource => routeSource.type && routeSource.type === type) || null
    }
  }
}
